// extracted by mini-css-extract-plugin
export default {"planConnector":"QuotaInsurancePlanStep_planConnector__MYPrr","planConnectorIcon":"QuotaInsurancePlanStep_planConnectorIcon__TDiN7"};